export { default } from "@catchy/app-core/src/useLocalStorage";
